var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLivelyBbyhLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "94pt",
    height: "44pt",
    viewBox: "0 0 244 91",
    style: {
      enableBackground: "new 0 0 244 91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000010;}\n\t.st1{fill:#FFF200;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000179610607678803540320000009800312452154010809_);}\n\t.st4{fill:url(#SVGID_00000144328147697573628460000017579377459829345168_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.2,22c0,2.1-1.6,3.7-3.7,3.7c-2.1,0-3.7-1.6-3.7-3.7s1.6-3.7,3.7-3.7C172.7,18.3,174.2,19.9,174.2,22z  M167.5,22c0,1.7,1.3,3.1,3,3.1s3-1.3,3-3.1s-1.3-3.1-3-3.1S167.5,20.2,167.5,22z M170.3,22.2h-0.7v1.9H169v-4.5h1.6 c1,0,1.6,0.5,1.6,1.3c0,0.6-0.2,1.1-1.1,1.2l1.1,1.9h-0.8L170.3,22.2L170.3,22.2z M171.5,21c0-0.4-0.2-0.7-0.8-0.7h-1.1v1.4h1.1 C171.3,21.7,171.5,21.3,171.5,21L171.5,21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,2.8h11.4v50.8H0V2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,17.4h11.5v36.2H17.9V17.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,17.4h12.2l8,24.3l7.8-24.3h11L58.2,53.6H45.5C45.5,53.6,32.3,17.4,32.3,17.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,54.4c-2.8,0-5.3-0.4-7.7-1.2c-2.4-0.8-4.4-2-6.1-3.6c-1.7-1.6-3-3.5-4-5.8c-1-2.3-1.4-4.9-1.4-7.8v-0.6 c0-2.9,0.5-5.5,1.5-7.8c1-2.3,2.3-4.3,4-5.9c1.7-1.6,3.7-2.9,6.1-3.8c2.3-0.9,4.9-1.3,7.6-1.3c2.4,0,4.7,0.4,6.9,1.1 c2.2,0.7,4.1,1.8,5.8,3.3s3,3.4,4,5.8c1,2.4,1.5,5.1,1.5,8.4v3.1H81.9c0.2,2.6,1,4.7,2.4,6.1c1.4,1.4,3.3,2.2,5.7,2.2 c2.2,0,3.8-0.4,4.8-1.3c1-0.9,1.7-2,1.9-3.3h10.9c-0.6,4-2.4,7.2-5.5,9.3S94.8,54.4,89.5,54.4L89.5,54.4z M96.3,31.5 c-0.2-4.8-2.5-7.3-6.9-7.3c-2,0-3.7,0.6-4.9,1.9c-1.3,1.2-2.1,3-2.5,5.4C82,31.5,96.3,31.5,96.3,31.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.5,49.9L126,17.4h12.5l8,20.2l7.3-20.2h11l-19.4,48.4h-11L140.5,49.9L140.5,49.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.6,84.5 71.2,84.5 71.2,82.1 77.3,82.1 77.3,78.6 71.2,78.6 71.2,76.7 78.6,76.7 78.6,73 66.3,73  66.3,88.2 78.6,88.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.2,73 91.2,76.7 95.3,76.7 95.3,88.2 100.2,88.2 100.2,76.7 104.2,76.7 104.2,73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "147.4,78.1 144.2,73 139.3,73 145,82.8 145,88.2 149.9,88.2 149.9,82.8 155.6,73 150.7,73  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,84.3c-0.3,0.3-0.6,0.4-1.1,0.4h-2.3v-2.7h2.3c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 S60.5,84,60.2,84.3 M56.8,76.5h1.8c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.9,0.3h-1.8 V76.5L56.8,76.5z M62.7,80.2l0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.4-0.5,0.5-0.9 c0.2-0.4,0.2-0.8,0.2-1.2c0-1.1-0.5-2-1.5-2.8c-1-0.8-2.4-1.2-4.1-1.2h-7.4v15.2h7.9c2,0,6.2-0.4,6.2-4.4 C66,80.8,62.8,80.2,62.7,80.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.6,84.3c-0.3,0.3-0.6,0.4-1.1,0.4h-2.3v-2.7h2.3c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 C120.1,83.7,119.9,84,119.6,84.3 M116.3,76.5h1.8c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8 c-0.2,0.2-0.5,0.3-0.9,0.3h-1.8V76.5L116.3,76.5z M122.1,80.1l0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.6-0.6 c0.2-0.2,0.4-0.5,0.5-0.9c0.2-0.4,0.2-0.8,0.2-1.2c0-1.1-0.5-2-1.5-2.8c-1-0.8-2.4-1.2-4.1-1.2h-7.4v15.2h7.9c2,0,6.2-0.4,6.2-4.4 C125.4,80.8,122.2,80.2,122.1,80.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.7,84.3c-0.3,0.2-0.6,0.4-1.1,0.4s-1-0.1-1.5-0.4c-0.5-0.3-0.9-0.5-1-0.6c-0.1-0.1-0.2-0.2-0.3-0.2 l-2.9,2.8l0.2,0.2c0.2,0.2,0.5,0.4,0.8,0.7c0.4,0.3,0.8,0.5,1.3,0.8c0.5,0.3,1.1,0.5,1.8,0.7c0.7,0.2,1.5,0.3,2.2,0.3 c1.9,0,3.5-0.5,4.6-1.5s1.7-2.2,1.7-3.6c0-0.8-0.2-1.5-0.5-2.1c-0.3-0.6-0.7-1.1-1.2-1.4c-0.5-0.3-1-0.6-1.6-0.8 c-0.5-0.2-1-0.4-1.5-0.5c0,0-0.1,0-0.1,0c-0.5-0.1-0.9-0.3-1.2-0.5c-0.3-0.2-0.5-0.4-0.5-0.6c0-0.3,0.1-0.5,0.3-0.7 c0.2-0.2,0.5-0.3,1-0.3c1,0,1.6,0.5,1.9,0.8l2.9-2.8l-0.1-0.1c-0.1-0.2-0.3-0.3-0.7-0.6c-0.3-0.2-0.7-0.4-1.1-0.6 c-0.4-0.2-0.9-0.4-1.6-0.5c-0.7-0.2-1.4-0.2-2.1-0.2c-1.8,0-3.3,0.5-4.4,1.4c-1.1,1-1.7,2.1-1.7,3.4c0,0.7,0.1,1.3,0.4,1.9 c0.2,0.6,0.6,1,0.9,1.3c0.4,0.3,0.8,0.6,1.3,0.9c0.4,0.2,0.8,0.4,1.2,0.5c0.1,0,0.2,0.1,0.2,0.1c0.5,0.2,0.9,0.3,1.3,0.4 c0.4,0.1,0.7,0.3,0.9,0.4c0.2,0.1,0.4,0.3,0.4,0.5C86,83.7,85.9,84,85.7,84.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.1,82c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8V73h-4.9v8.8c0,3.6,3,6.6,6.6,6.6h0.3c3.6,0,6.6-3,6.6-6.6 V73h-4.9V82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "155.7,81.3 167.8,81.3 167.8,91 155.7,91 152.7,88.1 152.7,84.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.1,86.1c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6S155.1,86.4,155.1,86.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.1,73 177.3,73 177.3,79.3 183.7,79.3 183.7,73 186.8,73 186.8,88.2 183.7,88.2 183.7,81.8  177.3,81.8 177.3,88.2 174.1,88.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.9,81.5c-0.1-1.8-1-2.6-2.5-2.6c-1.5,0-2.4,1-2.7,2.6H196.9z M188.7,82.8v-0.2c0-3.5,2.4-5.8,5.6-5.8 c2.8,0,5.3,1.7,5.3,5.7v0.8h-8.1c0.1,2,1.1,3.1,2.9,3.1c1.5,0,2.2-0.6,2.4-1.6h2.7c-0.4,2.4-2.3,3.7-5.2,3.7 C191.1,88.4,188.7,86.3,188.7,82.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.6,84.3v-1.7c-0.3,0.3-0.9,0.6-2,0.8c-1.2,0.2-2.2,0.6-2.2,1.7c0,0.8,0.5,1.4,1.7,1.4 C206.5,86.4,207.6,85.6,207.6,84.3 M200.6,85.2c0-2.6,2.4-3.2,5-3.6c1.4-0.2,2-0.6,2-1.4c0-0.8-0.5-1.3-1.9-1.3s-1.9,0.6-2,1.6H201 c0.2-2.6,2.3-3.7,4.9-3.7s4.6,1.1,4.6,3.9v7.5h-2.8v-1.4c-0.7,0.9-1.7,1.6-3.4,1.6C202.2,88.5,200.6,87.5,200.6,85.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.7,
    y: 72.6,
    className: "st0",
    width: 2.8,
    height: 15.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.3,85v-5.8h-1.5v-2.1h1.5v-2.4h2.8v2.4h2.4v2.1h-2.4v5.6c0,0.9,0.5,1.4,1.3,1.4c0.5,0,0.9-0.1,1.2-0.2v2.2 c-0.5,0.1-1,0.3-1.8,0.3C219.5,88.4,218.3,87.2,218.3,85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.1,72.6h2.8v6.3c0.6-1.1,1.8-2,3.6-2c2.2,0,3.8,1.3,3.8,4.3v7h-2.8v-6.7c0-1.6-0.6-2.3-2.1-2.3 S228,80,228,81.7v6.5h-2.8L225.1,72.6L225.1,72.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,72.9 8.9,72.9 8.9,74.4 1.9,74.4 1.9,79.9 7.4,79.9 7.4,81.4 1.9,81.4 1.9,88.2 0,88.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,77h1.8v2c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.6-0.3,1-0.5 c0.4-0.1,0.8-0.2,1.3-0.2v1.7c-0.6,0-1.1,0.1-1.5,0.2c-0.5,0.1-0.8,0.3-1.2,0.6s-0.6,0.6-0.7,1.1c-0.2,0.5-0.3,1-0.3,1.7v6.1h-1.8 C10.4,88.2,10.4,77,10.4,77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,88.4c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.2-0.7-1.7-1.2c-0.5-0.5-0.9-1.1-1.1-1.8 c-0.3-0.7-0.4-1.4-0.4-2.3v-0.2c0-0.8,0.1-1.6,0.4-2.3c0.3-0.7,0.7-1.3,1.1-1.8c0.5-0.5,1.1-0.9,1.7-1.2c0.7-0.3,1.4-0.4,2.2-0.4 s1.5,0.1,2.2,0.4c0.7,0.3,1.3,0.7,1.7,1.2c0.5,0.5,0.9,1.1,1.1,1.8c0.3,0.7,0.4,1.5,0.4,2.3v0.2c0,0.8-0.1,1.6-0.4,2.3 c-0.3,0.7-0.7,1.3-1.2,1.8c-0.5,0.5-1.1,0.9-1.7,1.2C23.6,88.3,22.9,88.4,22.1,88.4 M22.1,86.9c0.6,0,1.1-0.1,1.5-0.3 c0.5-0.2,0.8-0.5,1.2-0.9c0.3-0.4,0.6-0.8,0.7-1.3c0.2-0.5,0.3-1.1,0.3-1.7v-0.1c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.4-1-0.7-1.3 c-0.3-0.4-0.7-0.7-1.2-0.8c-0.5-0.2-0.9-0.3-1.5-0.3s-1.1,0.1-1.5,0.3s-0.8,0.5-1.2,0.8c-0.3,0.4-0.6,0.8-0.7,1.3 c-0.2,0.5-0.3,1.1-0.3,1.7v0.2c0,1.3,0.3,2.3,1,3.1C20.1,86.5,21,86.9,22.1,86.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.7,77h1.8v1.7c0.3-0.5,0.7-1,1.2-1.3c0.6-0.4,1.3-0.6,2.1-0.6c0.7,0,1.4,0.2,2,0.5c0.6,0.3,1,0.9,1.3,1.6 c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.3,0.6-0.5,1-0.7c0.3-0.2,0.7-0.3,1.1-0.4c0.4-0.1,0.7-0.1,1.1-0.1c0.5,0,1,0.1,1.4,0.2 c0.5,0.2,0.9,0.4,1.2,0.8c0.3,0.4,0.6,0.8,0.8,1.4c0.2,0.6,0.3,1.2,0.3,2.1v6.9h-1.8v-7c0-1-0.2-1.7-0.6-2.1 c-0.4-0.4-1-0.7-1.8-0.7c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.1-0.7,0.3-0.9,0.6c-0.3,0.2-0.5,0.6-0.7,0.9c-0.2,0.4-0.3,0.8-0.3,1.3v6.8 h-1.8v-7c0-1-0.2-1.7-0.6-2.1c-0.4-0.4-1-0.7-1.8-0.7c-0.4,0-0.7,0.1-1.1,0.2c-0.3,0.1-0.7,0.3-0.9,0.6c-0.3,0.2-0.5,0.6-0.7,0.9 c-0.2,0.4-0.3,0.8-0.3,1.3v6.8h-1.8L29.7,77L29.7,77z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "237.9,77.2 236.9,77.2 236.9,76.8 239.3,76.8 239.3,77.2 238.3,77.2 238.3,80.3 237.9,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "239.7,76.8 240.3,76.8 241.4,79.9 242.4,76.8 243,76.8 243,80.3 242.6,80.3 242.6,77.4 241.6,80.3  241.1,80.3 240.1,77.4 240.1,80.3 239.7,80.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.4766,
    y1: 67.3385,
    x2: 117.4766,
    y2: 179.0865,
    gradientTransform: "matrix(1 0 0 -1 0 143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#0253A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#133B89"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.3,50.2c0,3.4,2.8,6.2,6.2,6.2s6.2-2.7,6.2-6.1v-0.1c0-3.4-2.8-6.1-6.2-6.1 C114.1,44.1,111.3,46.8,111.3,50.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125580556802837982310000017744484769008087975_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.4766,
    y1: 67.7126,
    x2: 117.4766,
    y2: 176.4196,
    gradientTransform: "matrix(1 0 0 -1 0 143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#0253A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#133B89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125580556802837982310000017744484769008087975_)"
    },
    d: "M111.8,2.8h11.4v38.7h-11.4V2.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070086621625328545700000007020493969717604278_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.3892,
    y1: 108.636,
    x2: 23.3892,
    y2: 220.384,
    gradientTransform: "matrix(1 0 0 -1 0 143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#3382C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#0253A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#133B89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070086621625328545700000007020493969717604278_)"
    },
    d: "M17.2,9c0,3.4,2.8,6.2,6.2,6.2 s6.2-2.7,6.2-6.1V8.9c0-3.4-2.8-6.1-6.2-6.1S17.2,5.5,17.2,9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivelyBbyhLogoBlue);
export default __webpack_public_path__ + "static/media/lively-bbyh-logo-blue.812cda9261bd6b7a8697356cfbafc34f.svg";
export { ForwardRef as ReactComponent };